interface Props {
  heading: string
  subHeading: string
}

const PageHeader = ({ heading, subHeading }: Props) => (
  <>
    <h1 className="md:text-[45px] text-3xl font-natosans-medium leading-[1.1] mb-2.5">
      {heading}
    </h1>
    <h2 className="text-[#6bb51e] md:text-3xl text-xl leading-[1.4] my-2.5">
      {subHeading}
    </h2>
  </>
)

export default PageHeader
